import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Sobre = lazy(() => import('../pages/sobre/page'));
const Programas = lazy(() => import('../pages/programas/page'));
const MercadoTrabalho = lazy(() => import('../pages/mercado-trabalho/page'));
const Agenda = lazy(() => import('../pages/agenda/page'));
const Contato = lazy(() => import('../pages/contato/page'));
const Inscricoes = lazy(() => import('../pages/inscricoes/page'));
const Proposito = lazy(() => import('../pages/proposito/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/sobre',
    element: <Sobre />
  },
  {
    path: '/programas',
    element: <Programas />
  },
  {
    path: '/mercado-trabalho',
    element: <MercadoTrabalho />
  },
  {
    path: '/agenda',
    element: <Agenda />
  },
  {
    path: '/contato',
    element: <Contato />
  },
  {
    path: '/inscricoes',
    element: <Inscricoes />
  },
  {
    path: '/proposito',
    element: <Proposito />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
